"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldLisItemCoreInputs = void 0;
const common_1 = require("../../utils/common/common");
const list_item_variant_1 = require("./list-item.variant");
class EmeraldLisItemCoreInputs {
    constructor() {
        this.type = list_item_variant_1.EmeraldListItemVariant.DEFAULT;
        this.labelPosition = common_1.EmeraldLabelPosition.RIGHT;
        this.hasAvatar = false;
        this.radioGroup = `Radio${Math.random().toString()}`;
        this.enableRipple = true;
        this.title = '';
    }
}
exports.EmeraldLisItemCoreInputs = EmeraldLisItemCoreInputs;
//# sourceMappingURL=list-item.inputs.js.map